import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { compose, pure } from 'recompose';
const RouterOutlet = ({ routes, redirect, match }) => (React.createElement(Switch, null,
    routes &&
        routes.map((route) => (React.createElement(Route, { exact: route.exact, key: (match ? match.url : '') + route.path, path: (match ? match.url : '') + route.path, component: route.component }))),
    redirect && redirect.to && React.createElement(Redirect, { from: redirect.from, to: redirect.to })));
const ComposedRouterOutlet = compose(pure)(RouterOutlet);
ComposedRouterOutlet.displayName = 'RouterOutlet';
export default ComposedRouterOutlet;
//# sourceMappingURL=RouterOutlet.js.map